import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>De Magische Wereld van Vezels</title>
                <link rel="canonical" href={route("blogs.forty-nine")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Oké, laten we eerlijk zijn: vezels zijn niet het meest sexy onderwerp om over te praten. Maar het zijn wel kleine superhelden die in je eten rondhangen en je lichaam helpen om als een geoliede machine te werken. Dus laten we wat meer leren over deze onzichtbare vrienden, zodat we ze wat meer waardering kunnen geven!"
                />
                <meta
                    property="og:description"
                    content="Oké, laten we eerlijk zijn: vezels zijn niet het meest sexy onderwerp om over te praten. Maar het zijn wel kleine superhelden die in je eten rondhangen en je lichaam helpen om als een geoliede machine te werken. Dus laten we wat meer leren over deze onzichtbare vrienden, zodat we ze wat meer waardering kunnen geven!"
                />
                <meta property="og:url" content={route("blogs.forty-nine")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="De Magische Wereld van Vezels - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/wereld-van-vezels.png"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/wereld-van-vezels.webp"
                                    type="image/webp"
                                    alt="Vezels"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/wereld-van-vezels.png"
                                    type="image/jpeg"
                                    alt="Vezels"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/wereld-van-vezels.png"
                                    alt="Vezels"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        De Magische Wereld van Vezels
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Oké, laten we eerlijk zijn: vezels zijn niet het meest
                        sexy onderwerp om over te praten. Maar het zijn wel
                        kleine superhelden die in je eten rondhangen en je
                        lichaam helpen om als een geoliede machine te werken.
                        Dus laten we wat meer leren over deze onzichtbare
                        vrienden, zodat we ze wat meer waardering kunnen geven!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat zijn vezels eigenlijk?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vezels zijn een soort koolhydraten die je lichaam niet
                        kan verteren. Ze reizen door je lichaam, maken een
                        beetje een puinhoop, en verlaten dan het pand zonder een
                        fooi achter te laten (niet echt beleefd, maar we hebben
                        ze nog steeds nodig). Er zijn twee soorten vezels:
                        oplosbare vezels, die water opnemen en een soort gel
                        vormen die helpt bij de spijsvertering, en onoplosbare
                        vezels, die helpen om dingen in beweging te houden in je
                        spijsverteringsstelsel (Anderson, Baird, Davis Jr,
                        Ferreri, Knudtson, Koraym, Waters, & Williams, 2009).
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom zijn vezels zo geweldig?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vezels zijn de onbezongen helden van de voedingswereld.
                        Ze helpen niet alleen bij de spijsvertering, maar kunnen
                        ook het risico op hartaandoeningen verminderen, je
                        helpen om je gewicht onder controle te houden en je
                        bloedsuikerspiegel stabiel te houden (Anderson et al.,
                        2009). En als dat nog niet genoeg is, kunnen ze ook
                        helpen om je cholesterolgehalte te verlagen. Kortom,
                        vezels zijn de vriend die je altijd al wilde hebben,
                        maar nooit wist dat je nodig had.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoeveel vezels heb je nodig?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Volgens de Voedingsraad (2015) zou je dagelijks ongeveer
                        30 tot 40 gram vezels moeten binnenkrijgen. Maar laten
                        we eerlijk zijn, de meesten van ons halen dat niet. Dus
                        hoe kun je meer vezels in je dieet krijgen? Het is
                        eigenlijk vrij eenvoudig: eet meer groenten, fruit,
                        volkoren producten en bonen. En als je echt avontuurlijk
                        bent, kun je zelfs wat lijnzaad aan je ochtendyoghurt
                        toevoegen. Je darmen zullen je dankbaar zijn!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waar vind je vezels?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vezels zijn overal om ons heen (nou ja, in ons eten
                        dan). Ze zitten in groenten en fruit, volkoren
                        producten, bonen, noten en zaden. Sommige
                        voedingsmiddelen, zoals chiazaad en lijnzaad, zijn echte
                        vezelbommen. Maar ook in minder voor de hand liggende
                        producten, zoals popcorn en aardappelen, zitten veel
                        vezels (Slavin, 2008). Dus de volgende keer dat je een
                        filmavond plant, sla dan de chips over en ga voor de
                        popcorn. Je lichaam zal je dankbaar zijn!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vezels zijn misschien niet het meest glamoureuze
                        onderwerp, maar ze zijn wel super belangrijk voor onze
                        gezondheid. Dus laten we ze wat meer liefde geven en
                        ervoor zorgen dat we er genoeg van binnenkrijgen. Want
                        zoals het oude gezegde luidt: een vezel per dag houdt de
                        dokter weg (oké, dat is misschien niet het exacte
                        gezegde, maar je snapt het idee).
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Anderson, J. W., Baird, P., Davis Jr, R. H., Ferreri,
                        S., Knudtson, M., Koraym, A., Waters, V., & Williams, C.
                        L. (2009). Health benefits of dietary fiber. Nutrition
                        reviews, 67(4), 188-205.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Slavin, J. (2008). Position of the American Dietetic
                        Association: health implications of dietary fiber.
                        Journal of the American Dietetic Association, 108(10),
                        1716-1731.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Voedingsraad. (2015). Richtlijnen goede voeding 2015.
                        Den Haag: Voedingsraad.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
